import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NoteViewerComponent } from './note-viewer.component';
import { NoteViewerRoutingModule } from './note-viewer-routing.module';
import { TdoMultiselectDropdownModule } from '../../../tdo-controls/common/tdo-multiselect-dropdown/tdo-multiselect-dropdown.module';

// material
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  declarations: [
    NoteViewerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NoteViewerRoutingModule,
    TdoMultiselectDropdownModule,

    // material
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    NoteViewerComponent
  ]
})
export class NoteViewerModule { }
